export default __webpack_public_path__ + "static/media/AM_logo_FINAL_black.9c2bd6a0.svg";